/* ============================================================
   North & Under — Shopify Theme JS
   Handles: Nav scroll, fade-in animations, announcement bar,
            animated counters
   ============================================================ */

(function () {
  'use strict';

  /* --- Announcement Bar Dismiss --- */
  const announce = document.querySelector('.nu-announce');
  const announceClose = document.querySelector('.nu-announce__close');

  function getAnnounceHeight() {
    if (!announce || announce.classList.contains('is-hidden')) return 0;
    return announce.offsetHeight;
  }

  if (announce && announceClose) {
    // Restore dismissed state from sessionStorage
    if (sessionStorage.getItem('nu-announce-dismissed') === '1') {
      announce.classList.add('is-hidden');
    }
    announceClose.addEventListener('click', function () {
      announce.classList.add('is-hidden');
      sessionStorage.setItem('nu-announce-dismissed', '1');
      updateNavTop();
    });
  }

  /* --- Sticky Nav Background --- */
  const nav = document.querySelector('.nu-nav');

  function updateNavTop() {
    if (!nav) return;
    nav.style.top = getAnnounceHeight() + 'px';
  }

  function handleScroll() {
    if (!nav) return;
    if (window.scrollY > 80) {
      nav.classList.remove('nu-nav--transparent');
      nav.classList.add('nu-nav--solid');
    } else {
      nav.classList.remove('nu-nav--solid');
      nav.classList.add('nu-nav--transparent');
    }
  }

  // Initial state
  updateNavTop();
  handleScroll();
  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', updateNavTop, { passive: true });

  /* --- Fade-In on Scroll (IntersectionObserver) --- */
  const fadeEls = document.querySelectorAll('.nu-fade');

  if ('IntersectionObserver' in window && fadeEls.length) {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // Respect data-delay attribute for staggered animations
            const delay = entry.target.dataset.delay || 0;
            setTimeout(function () {
              entry.target.classList.add('is-visible');
            }, delay * 1000);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    fadeEls.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    // Fallback: show everything immediately
    fadeEls.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* --- Animated Counters --- */
  const counters = document.querySelectorAll('[data-count-to]');

  if ('IntersectionObserver' in window && counters.length) {
    const counterObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            counterObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );
    counters.forEach(function (el) {
      counterObserver.observe(el);
    });
  }

  function animateCounter(el) {
    const target = parseInt(el.dataset.countTo, 10);
    const duration = parseInt(el.dataset.countDuration || '1200', 10);
    const start = performance.now();

    function tick(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      // Ease-out quad
      const eased = 1 - (1 - progress) * (1 - progress);
      el.textContent = Math.round(eased * target);
      if (progress < 1) {
        requestAnimationFrame(tick);
      }
    }
    requestAnimationFrame(tick);
  }

  /* --- Countdown Timer --- */
  var cdEl = document.getElementById('nu-countdown');
  if (cdEl) {
    var launchDate = new Date(cdEl.dataset.launch);
    var daysEl = document.getElementById('nu-cd-days');
    var hoursEl = document.getElementById('nu-cd-hours');
    var minsEl = document.getElementById('nu-cd-mins');
    var secsEl = document.getElementById('nu-cd-secs');

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function updateCountdown() {
      var now = new Date();
      var diff = launchDate - now;

      if (diff <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minsEl.textContent = '00';
        secsEl.textContent = '00';
        return;
      }

      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minsEl.textContent = pad(mins);
      secsEl.textContent = pad(secs);
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  /* --- Mobile Nav Toggle --- */
  var hamburger = document.getElementById('nu-hamburger');
  var mobileNav = document.getElementById('nu-mobile-nav');
  var mobileClose = document.getElementById('nu-mobile-close');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    if (mobileClose) {
      mobileClose.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }

    // Close on link click
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  /* --- Product Page: Anchor Scroll-Spy + Smooth Scroll --- */
  var anchorsBar = document.getElementById('nu-anchors');
  if (anchorsBar) {
    var anchorLinks = anchorsBar.querySelectorAll('.nu-anchors__link');
    var sectionIds = [];
    anchorLinks.forEach(function (link) {
      sectionIds.push(link.getAttribute('data-anchor'));
    });

    // Smooth scroll on click
    anchorLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var targetId = this.getAttribute('data-anchor');
        var target = document.getElementById(targetId);
        if (target) {
          var navH = nav ? nav.offsetHeight : 0;
          var anchorH = anchorsBar.offsetHeight;
          var top = target.getBoundingClientRect().top + window.scrollY - navH - anchorH - 20;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });

    // Scroll-spy: highlight active anchor
    function updateActiveAnchor() {
      var navH = nav ? nav.offsetHeight : 0;
      var anchorH = anchorsBar.offsetHeight;
      var offset = navH + anchorH + 60;
      var current = '';
      sectionIds.forEach(function (id) {
        var sec = document.getElementById(id);
        if (sec && sec.getBoundingClientRect().top <= offset) {
          current = id;
        }
      });
      anchorLinks.forEach(function (link) {
        link.classList.toggle('is-active', link.getAttribute('data-anchor') === current);
      });
    }
    window.addEventListener('scroll', updateActiveAnchor, { passive: true });
    updateActiveAnchor();

    // Position anchor bar below nav
    function positionAnchors() {
      if (nav) {
        anchorsBar.style.top = nav.offsetHeight + 'px';
      }
    }
    positionAnchors();
    window.addEventListener('resize', positionAnchors, { passive: true });
    window.addEventListener('scroll', positionAnchors, { passive: true });
  }

  /* --- Product Page: FAQ Accordion --- */
  var faqItems = document.querySelectorAll('.nu-faq__item');
  faqItems.forEach(function (item) {
    var btn = item.querySelector('.nu-faq__question');
    var answer = item.querySelector('.nu-faq__answer');
    if (btn && answer) {
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        // Close all others
        faqItems.forEach(function (other) {
          other.classList.remove('is-open');
          var otherAnswer = other.querySelector('.nu-faq__answer');
          if (otherAnswer) otherAnswer.style.maxHeight = null;
          var otherBtn = other.querySelector('.nu-faq__question');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        });
        // Toggle current
        if (!isOpen) {
          item.classList.add('is-open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    }
  });

  /* --- Product Page: Specs Tab Toggle --- */
  var specsTabs = document.querySelectorAll('.nu-ps__tab');
  var specsPanels = document.querySelectorAll('.nu-ps__panel');
  specsTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = this.getAttribute('data-tab');
      specsTabs.forEach(function (t) { t.classList.remove('is-active'); });
      specsPanels.forEach(function (p) { p.classList.remove('is-active'); });
      this.classList.add('is-active');
      var panel = document.querySelector('[data-panel="' + target + '"]');
      if (panel) panel.classList.add('is-active');
    });
  });

  /* --- N&U Cart Drawer Trigger --- */
  var cartTriggers = document.querySelectorAll('.nu-cart-trigger');
  cartTriggers.forEach(function (btn) {
    btn.addEventListener('click', function () {
      // Find the N&U standalone cart drawer (outside #header-group)
      var drawer = document.querySelector('#nu-cart-drawer-wrap cart-drawer-component');
      if (drawer && typeof drawer.showDialog === 'function') {
        drawer.showDialog();
      } else if (drawer) {
        // Fallback: try finding the dialog and showing it
        var dialog = drawer.querySelector('dialog');
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
      } else {
        // Final fallback: go to cart page
        window.location.href = '/cart';
      }
      // Close mobile nav if open
      if (mobileNav && mobileNav.classList.contains('is-open')) {
        mobileNav.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  });
})();
